module.exports = __webpack_public_path__ + "static/img/yytx32.eb57992.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx32.png
// module id = 810
// module chunks = 0